import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, exhaustMap, map, scan, startWith, switchMap, takeWhile, tap } from 'rxjs/operators';
interface AutoConfig {
  value: string
  display: string
}
@Component({
  selector: 'auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss']
})
export class AutoCompleteComponent implements OnInit, OnDestroy {
  @Input() fieldCtrl: FormControl;
  @Input('config') config: any = { key: 'id', display: 'name' }
  list = [];
  @ViewChild('focused') focused: ElementRef;
  @Input() action?: string;
  @Input("list") set updateSmartList(data: any) {
    if (data && data.length) {
      this.list = data;
      this.getFilteredList();
    } else {
      this.list = [];
      this.getFilteredList();
    }
  }
  @Input() defaultValue?: any;
  @Input() placeHolder: string;
  @Input() appearance?: string;
  @Output() optionSelected = new EventEmitter();
  toHighlight = "";
  filteredList: Observable<any[]>;
  private nextPage$ = new Subject();

  constructor() { }

  ngOnInit(): void {
    this.getFilteredList();
  }

  /**
   * Result = of(currInputVal)
   */
  getChangedValOfInput() {    
    const filter$ = this.fieldCtrl.valueChanges.pipe(
      startWith(""),
      debounceTime(400)
      // Note: If the option valye is bound to object, after selecting the option
      // Note: the value will change from string to {}. We want to perform search
      // Note: only when the type is string (no match)
      // filter(q => typeof q === 'string')
    );
    return filter$;
  }

  getFilteredList() {
    const filter$ = this.getChangedValOfInput();
    this.filteredList = filter$.pipe(
      switchMap(currInputVal => {
        // Note: Reset the page with every new seach text
        let currentPage = 1;
        return this.nextPage$.pipe(
          startWith(currentPage),
          // Note: Until the backend responds, ignore NextPage requests.
          exhaustMap(_ => this.getItems(currInputVal, currentPage)),
          tap(() => currentPage++),
          // Note: This is a custom operator because we also need the last emitted value.
          // Note: Stop if there are no more pages, or no results at all for the current search text.
          takeWhile(p => p.length > 0, true),
          scan(
            (allProducts, newProducts) => allProducts.concat(newProducts)
          )
        );
      })
    );
  }

  private getItems(startsWith: any, page: number): Observable<any[]> {
    const take = 10;
    const skip = page > 0 ? (page - 1) * take : 0;
    let filterValue = "";
    // console.log(startsWith[this.conf.display], '=', this.conf);
    if ((startsWith || {})[this.config.display]) {
      filterValue = (startsWith[this.config.display] || "").toLowerCase();
    } else {
      filterValue = (startsWith || "").toString().toLowerCase();
    }
    const filtered = this.list.filter(
      (option: any) => option[this.config.display].toLowerCase().indexOf(filterValue) >= 0
    );
    return of(filtered.slice(skip, skip + take));
  }

  onSelect(event: any) {
    this.toHighlight = event[this.config.display];
    this.optionSelected.emit(event);
  }

  onScroll() {
    this.nextPage$.next();
  }

  displayFn(data: any): string {
    return data && data[this.config.display] ? data[this.config.display] : '';
  }

  ngOnDestroy() {
    this.nextPage$.unsubscribe();
    if (this.optionSelected) {
      this.optionSelected.unsubscribe();
    }
  }
}
